import { graphql } from 'react-relay';

const cancelPortfolioOrderRequestMutation = graphql`
  mutation CancelPortfolioOrderRequestMutation(
    $approvableId: ID!
  ) {
    cancelApprovable(
      approvableId: $approvableId
    ) {
      approvable {
        __typename
        ... on PortfolioOrderRequestNode {
          status
          approvals {
            edges {
              node {
                id
                approvedAt
                approvedBy {
                  username
                  fullName
                  email
                }
              }
            }
          }
          portfolioOrder {
            id
            stockOrders {
              edges {
                node {
                  id
                  contract {
                    id
                    symbol
                  }
                  
                  brokerOrder {
                    id
                    status
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default cancelPortfolioOrderRequestMutation;
